<template>
	<div class="container">
		<div class="left-menu" :style="{
        width: !isCollapse ? '12%' : '4.5%',
        textAlign: !isCollapse ? 'left' : 'center',
      }">
			<left-list :leftIndex="'6'" :isCollapse="isCollapse"></left-list>
		</div>
		<div class="right-content" :style="{ width: !isCollapse ? '88%' : '95.5%' }">
			<div class="top-nav">
				<top-header @openMenu="openMenu" :isCollapse="isCollapse"></top-header>
			</div>
			<div class="left-list">
				<div class="left-list-title">
					<span>产品在线监测</span>
				</div>
				<div class="left-list-item" @click="leftClick('0')">
					<span>传感器列表</span>
				</div>
				<div class="left-list-item left-list-active" @click="leftClick('1')">
					<span>设备列表</span>
				</div>
				<!-- <div class="left-list-item" @click="leftClick('1')">
					<span>知识列表</span>
				</div> -->
			</div>
			<div class="right-next">
				<div class="title">
					<span>{{title}}</span>
				</div>
				<div class="edit-form">
					<div class="item">
						<div class="label">公司名称:</div>
						<el-select v-model="editForm.corporateid" clearable placeholder="请选择公司">
							<el-option v-for="item in options" :key="item.id" :label="item.name" :value="item.id">
							</el-option>
						</el-select>
					</div>
					<div class="item">
						<div class="label">矿山名称:</div>
						<el-select v-model="editForm.mine_name" clearable placeholder="请选择矿山">
							<el-option v-for="item in mineList" :key="item.id" :label="item.name" :value="item.id">
							</el-option>
						</el-select>
					</div>
					<div class="item">
						<div class="label">设备名称：</div>
						<el-input placeholder="设备名称" v-model="editForm.name"></el-input>
					</div>
					<!-- <div class="item">
						<div class="label">磨机类型:</div>
						<el-select v-model="editForm.mill_type" clearable placeholder="请选择磨机类型">
							<el-option v-for="item in millType" :key="item.id" :label="item.name" :value="item.id">
							</el-option>
						</el-select>
					</div>
					<div class="item">
						<div class="label">磨机长度：</div>
						<el-input placeholder="磨机长度" type="number" v-model="editForm.size"></el-input>
					</div>
					<div class="item">
						<div class="label">磨机直径：</div>
						<el-input placeholder="磨机直径" v-model="editForm.diameter"></el-input>
					</div> -->
					<div class="item submit">
						<el-button type="primary" @click="submitUpload">保存添加</el-button>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import leftList from "../../components/leftList.vue";
	import topHeader from "../../components/header.vue"
	export default {
		components: {
			leftList,
			topHeader
		},
		inject: ["reload"],
		data() {
			return {
				title: '添加设备',
				isCollapse: false,
				uploadHeaders: {
					"Remember-Token": localStorage.getItem("rememberToken"),
				},
				options: [],
				mineList: [],
				millType: [{
						id: 1,
						name: '半自磨'
					},
					{
						id: 2,
						name: '自磨'
					},
					{
						id: 3,
						name: '球磨'
					}
				],
				editForm: {
					corporateid: '',
					mine_name: '',
					name: '',
					mill_type: '',
					size: '',
					diameter: '',
				},
			};
		},
		created() {
			if (this.$route.query.id) {
				this.title = '编辑设备';
				this.getinfo();
			}
			this.getCompanylist();
			this.getMinelist();
		},
		methods: {
			getinfo() {
				this.$get('mill/get_details', {
					id: this.$route.query.id
				}).then(res => {
					console.log(res);
					this.editForm.corporateid = res.data.data.company_id;
					this.editForm.mine_name = res.data.data.mine_id;
					if(res.data.data.mill_category == '半自磨'){
						res.data.data.mill_categoryid = 1;
					} else if(res.data.data.mill_category == '自磨'){
						res.data.data.mill_categoryid = 2;
					} else{
						res.data.data.mill_categoryid = 3;
					}
					this.editForm.name = res.data.data.name;
					this.editForm.mill_type = res.data.data.mill_categoryid;
					this.editForm.size = res.data.data.mill_length;
					this.editForm.diameter = res.data.data.mill_diameter;
				})
			},
			submitUpload() {
				// let _this = this;
				if (this.editForm.corporateid == '') {
					this.$notify.error({
						title: '提示',
						message: '请选择公司'
					});
					return false;
				}
				if (this.editForm.mill_name == '') {
					this.$notify.error({
						title: '提示',
						message: '请选择矿山'
					});
					return false;
				}
				if (this.editForm.name == '') {
					this.$notify.error({
						title: '提示',
						message: '请填写磨机名称'
					});
					return false;
				}
				// if (this.editForm.mine_type == '') {
				// 	this.$notify.error({
				// 		title: '提示',
				// 		message: '请选择磨机类型'
				// 	});
				// 	return false;
				// }
				// if (this.editForm.size == '') {
				// 	this.$notify.error({
				// 		title: '提示',
				// 		message: '请填写磨机长度'
				// 	});
				// 	return false;
				// }
				// if (this.editForm.diameter == '') {
				// 	this.$notify.error({
				// 		title: '提示',
				// 		message: '请填写磨机直径'
				// 	});
				// 	return false;
				// }
				if (this.$route.query.id) {
					this.$post('upd/mill', {
						id:this.$route.query.id,
						company_id: this.editForm.corporateid,
						mine_id: this.editForm.mine_name,
						name:this.editForm.name,
						mill_category:this.editForm.mill_type,
						mill_length:this.editForm.size,
						mill_diameter:this.editForm.diameter
					}).then(res =>{
						if (res.data.status == 200) {
							this.$notify({
								title: "提示",
								message: "操作成功！",
								type: "success",
							});
							this.$router.push("/mill");
						} else {
							this.$notify.error({
								title: "提示",
								message: res.data.message,
							});
						}
					})
				} else {
					this.$post('add/mill', {
						company_id: this.editForm.corporateid,
						mine_id: this.editForm.mine_name,
						name:this.editForm.name,
						mill_category:this.editForm.mill_type,
						mill_length:this.editForm.size,
						mill_diameter:this.editForm.diameter
					}).then(res =>{
						if (res.data.status == 200) {
							this.$notify({
								title: "提示",
								message: "操作成功！",
								type: "success",
							});
							this.$router.push("/mill");
						} else {
							this.$notify.error({
								title: "提示",
								message: res.data.message,
							});
						}
					})
				}
			},
			commodityAdd() {
				this.commodityList.push({
					commodity: '',
					units: '',
					avg_Annual: ''
				})
			},
			getMinelist() {
				this.$get('mine/get_list', {
					num: 999
				}).then(res => {
					console.log(res);
					this.mineList = res.data.data.data;
				})
			},
			getCompanylist() {
				this.$get('company/get_list', {
					num: 999
				}).then(res => {
					console.log(res);
					this.options = res.data.data.data;
				})
			},
			leftClick(index) {
				if (index == 0 && this.$route.path != "/sensor") {
					this.$router.push("/sensor");
				} else if(index == 1 && this.$route.path != "/mill"){
					this.$router.push("/mill");
				} else {
					this.reload();
				}
			},
			openMenu() {
				this.isCollapse = !this.isCollapse;
			},
		},
	};
</script>

<style lang="scss">
	.quill-editor {
		margin-top: 20px;
		width: 80%;
	}

	.ql-editor {
		height: 230px;
	}

	.avatar-uploader .el-upload {
		border: 1px dashed #d9d9d9;
		border-radius: 6px;
		cursor: pointer;
		position: relative;
		overflow: hidden;
	}

	.avatar-uploader .el-upload:hover {
		border-color: #409eff;
	}

	.avatar-uploader-icon {
		font-size: 28px;
		color: #8c939d;
		width: 178px;
		height: 178px;
		line-height: 178px;
		text-align: center;
	}

	.avatar-uploader {
		display: inline-block;
		vertical-align: top;
	}

	.avatar {
		width: 178px;
		height: 178px;
		// display: block;
	}

	.right-content {
		height: 100vh;
		overflow-x: hidden;
		overflow-y: scroll;
		vertical-align: top;
		display: inline-block;

		&::-webkit-scrollbar {
			display: none;
		}

		.date-search {
			margin-top: 30px;

			.el-button {
				padding: 12px 55px;
			}
		}

		.left-list {
			width: 10%;
			height: 93vh;
			overflow-x: hidden;
			overflow-y: scroll;
			font-size: 14px;
			border-right: 20px solid #f2f2f2;
			display: inline-block;
			text-align: center;

			&::-webkit-scrollbar {
				display: none;
			}

			&-title {
				margin: 20px 0;
				font-size: 16px;
			}

			&-item {
				padding: 15px 0;
				cursor: pointer;
				transition: all 0.2s;

				&:hover {
					color: #fff;
					background-color: #3291f8;
				}
			}

			&-active {
				color: #fff;
				background-color: #3291f8;
			}
		}

		.right-next {
			height: 93vh;
			width: 88.5%;
			overflow-x: hidden;
			overflow-y: scroll;
			border-top: 20px solid #f2f2f2;
			padding: 20px;
			box-sizing: border-box;
			display: inline-block;
			vertical-align: top;

			&::-webkit-scrollbar {
				display: none;
			}
		}

		.title {
			color: #000;
			height: 10px;
			padding-left: 15px;
			line-height: 10px;
			border-left: 5px solid #80c4f8;
			margin-bottom: 10px;
		}

		.edit-form {
			.submit {
				width: 25%;
				text-align: center;

				.el-button {
					width: 150px;
				}
			}

			.item {
				margin-top: 30px;

				.label {
					display: inline-block;
					vertical-align: middle;
					width: 120px;
				}

				.yield {
					margin-left: 30px;
					font-size: 14px;

					.commodity {
						margin-top: 15px;

						.el-button {
							margin-left: 15px;
						}
					}
				}

				.el-input,
				.el-select {
					width: 230px;
				}

				input[type=number]::-webkit-inner-spin-button,
				input[type=number]::-webkit-outer-spin-button {
					-webkit-appearance: none;
					margin: 0;
				}
			}
		}

		.top-nav {
			display: flex;
			box-sizing: border-box;
			justify-content: space-between;
			padding: 15px;

			.left-icon {
				i {
					cursor: pointer;
					color: #3291f8;
					font-size: 30px;
				}

				.el-icon-refresh-right {
					margin-left: 30px;
				}
			}

			.right-user {
				font-size: 14px;

				span {
					vertical-align: middle;
					margin-right: 20px;
				}

				.colse-btn {
					cursor: pointer;
					vertical-align: middle;
					border: 1px solid #999;
					display: inline-block;
					padding: 5px 20px;
					border-radius: 50px;

					span {
						margin-right: 10px;
					}

					i {
						vertical-align: middle;
					}
				}
			}
		}
	}

	.left-menu {
		display: inline-block;

		.iconyonghuzu {
			font-size: 18px;
			margin: 0 5px;
		}
	}

	.el-menu {
		width: 100%;
		background-color: #20222a;
		height: 100vh;
	}

	.el-menu-vertical-demo:not(.el-menu--collapse) {
		background-color: #20222a;
		color: #fff;
		height: 100vh;
		width: 100%;
	}

	.el-menu-item:focus,
	.el-menu-item:hover {
		color: #000;
		background-color: #ecf5ff;
	}

	.el-menu-item {
		color: #fff;

		i {
			color: #3291f8;
		}
	}

	.el-menu-item.is-active {
		background-color: #ecf5ff;
		color: #20222a;
	}

	.menu-h5 {
		margin: 20px;
		text-align: center;
		font-size: 20px;
	}

	.menu-icon {
		width: 100%;
		color: #fff;
		box-sizing: border-box;
		padding: 30px 22px;
	}
</style>
